import config from './../config/config';
import router from './../router/router';
import aguid from 'aguid';

const highScoreView = {
  /**
   * Sets everythign up
   * @returns {undefined} undefined
   */
  init() {
    this.element = document.getElementsByClassName('high-score-view')[0];
    this.form = this.element.getElementsByClassName('info')[0];
    this.input = this.form.getElementsByClassName('high-score-input')[0];
    this.closeButton = this.element.getElementsByClassName('close')[0];

    this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.closeButton.addEventListener('click', this.hide.bind(this));
  },


  /**
   * Shows the overlay
   * @param {Number} totalMadeShots - The user's total amount of made shots
   * @param {Number} shotPercentage - The user's shot percentage
   * @returns {undefined} undefined
   */
  show(totalMadeShots, shotPercentage) {
    const showClass = ' show';

    this.userTotalMadeShots = totalMadeShots;
    this.userShotPercentage = shotPercentage;
    this.element.className += showClass;
  },


  /**
   * Hides the overlay
   * @returns {undefined} undefined
   */
  hide() {
    const currentClass = this.element.className;
    const newClass = currentClass.split(' show').join('');

    this.element.className = newClass;
    router.currentView.destroy();
    router.currentView.init(true);
    this.reset();
  },


  /**
   * Gets token to make api calls
   * @returns {undefined} undefined
   */
  getApiToken() {
    const formData = new FormData();
    window._sessionId = aguid();
    formData.append('sessionId', window._sessionId);

    // Get highest shot percentag scores
    fetch(config.apiEndpoint + 'tokens', {
      method: 'post',
      body: formData,
    }).then((response) => {
      return response.json();
    }).then((json) => {
      window._sessionToken = json.token;
    }).catch((ex) => {
      console.log('Failed to get token', ex);
    });
  },


  /**
   * Form submit handler
   * @returns {undefined} undefined
   */
  onFormSubmit(e) {
    if (this.userTotalMadeShots &&
      this.userShotPercentage &&
      this.input.value) {
      const formData = new FormData();

      formData.append('high_score', {});
      formData.append('high_score[name]', this.input.value);
      formData.append('high_score[shots_made]', this.userTotalMadeShots);
      formData.append('high_score[shot_percentage]', this.userShotPercentage);

      // Get highest shot percentag scores
      fetch(config.apiEndpoint + 'high_scores', {
        method: 'post',
        body: formData,
        headers: {
          Authorization: window._sessionToken,
        },
      }).then((response) => {
        return response.json();
      }).then(() => {
        this.getApiToken();
        this.hide();
      }).catch((ex) => {
        console.log('high shot percentage scores parsing failed', ex);
      });
    } else {
      this.hide();
    }

    e.preventDefault();
  },


  /**
   * Resets the input field
   * @returns {undefined} undefined
   */
  reset() {
    this.userTotalMadeShots = null;
    this.userShotPercentage = null;
    this.input.value = '';
  },
};

export default highScoreView;



/** WEBPACK FOOTER **
 ** ./assets/js/src/views/high-score-view.js
 **/